import ModelFactory from '../model-factory';
import BookmarkItem from './bookmark-item';

export default class Bookmark {
  constructor(data = {}) {
    const keys = Object.keys(data);
    this.type = null;
    if (keys.length === 1) {
      const [type] = keys;
      this.type = type;
    }

    this.items = [];
    if (this.type != null && data[this.type] != null) {
      this.items = (data[this.type] || []).map((item) => new BookmarkItem(item));
    }
  }

  addItem(element, name) {
    this.items.push(new BookmarkItem({
      element, name,
    }));
  }

  removeItem(element) {
    const idx = this.items.findIndex((item) => item.element === element);
    if (idx >= 0) {
      this.items.splice(idx, 1);
    }
  }
}

export const modelFactory = new ModelFactory('bookmark', (data) => new Bookmark(data));
